<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12" sm="12" lg="12">
        <ul class="nav nav-tabs">
          <li  class="nav-item">
            <a @click="setActive('bmr-calc')" class="nav-link"  :class="activeTab == 'bmr-calc' ? ' active' : ''" >BMR</a>
          </li>
          <li class="nav-item">
            <a @click="setActive('body-mass')" class="nav-link"  :class="activeTab == 'body-mass' ? ' active' : ''" >Body Mass</a>
          </li>
          <li class="nav-item">
            <a @click="setActive('body-mass-children')" class="nav-link"  :class="activeTab == 'body-mass-children' ? ' active' : ''" >Body Mass Children</a>
          </li>
          <li class="nav-item">
            <a @click="setActive('calory-calculator')" class="nav-link"  :class="activeTab == 'calory-calculator' ? ' active' : ''" >Calorie</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('cbc')" class="nav-link"  :class="activeTab == 'cbc' ? ' active' : ''" >CBC</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('daily_calorie_calculator')" class="nav-link"  :class="activeTab == 'daily_calorie_calculator' ? ' active' : ''" >Daily Calorie</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('excercise_calorie_calculator')" class="nav-link"  :class="activeTab == 'excercise_calorie_calculator' ? ' active' : ''" >Exercise Calorie</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('ideal_body_weight_calculator_adults')" class="nav-link"  :class="activeTab == 'ideal_body_weight_calculator_adults' ? ' active' : ''" >Ideal Body Weight</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('liquid_calorie_calculator')" class="nav-link"  :class="activeTab == 'liquid_calorie_calculator' ? ' active' : ''" >Liquid Calorie</a>
          </li>

          
          <li class="nav-item">
            <a @click="setActive('overweight_calculator')" class="nav-link"  :class="activeTab == 'overweight_calculator' ? ' active' : ''" >Overweight</a>
          </li>
          
          <li class="nav-item">
            <a @click="setActive('weight-loss-calculator')" class="nav-link"  :class="activeTab == 'weight-loss-calculator' ? ' active' : ''" >Weight Loss</a>
          </li>

        </ul>
      </b-col>




      <b-col v-if="activeTab=='bmr-calc'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'bmr-calc')" ref="bmr-calc" :src="serverUrl+'calculators/bmr.php'" frameborder="0"></iframe>
      </b-col>
      <b-col v-if="activeTab=='body-mass'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'body-mass')" ref="body-mass" :src="serverUrl+'calculators/body_mass_index_calculator.htm'" frameborder="0"></iframe>
      </b-col>
      <b-col v-if="activeTab=='body-mass-children'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'body-mass-children')" ref="body-mass-children" :src="serverUrl+'calculators/body_mass_index_calculator_children.htm'" frameborder="0"></iframe>
      </b-col>
      <b-col v-if="activeTab=='calory-calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'calory-calculator')" ref="calory-calculator" :src="serverUrl+'calculators/calory_calculator.html'" frameborder="0"></iframe>
      </b-col>
      <b-col v-if="activeTab=='cbc'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'cbc')" ref="cbc" :src="serverUrl+'calculators/cbc.php'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='daily_calorie_calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'daily_calorie_calculator')" ref="daily_calorie_calculator" :src="serverUrl+'calculators/daily_calorie_calculator.htm'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='excercise_calorie_calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'excercise_calorie_calculator')" ref="excercise_calorie_calculator" :src="serverUrl+'calculators/excercise_calorie_calculator.htm'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='ideal_body_weight_calculator_adults'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'ideal_body_weight_calculator_adults')" ref="ideal_body_weight_calculator_adults" :src="serverUrl+'calculators/ideal_body_weight_calculator_adults.htm'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='liquid_calorie_calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'liquid_calorie_calculator')" ref="liquid_calorie_calculator" :src="serverUrl+'calculators/liquid_calorie_calculator.htm'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='overweight_calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'overweight_calculator')" ref="overweight_calculator" :src="serverUrl+'calculators/overweight_calculator.php'" frameborder="0"></iframe>
      </b-col>
      
      <b-col v-if="activeTab=='weight-loss-calculator'" md="12" sm="12" lg="12">
        <iframe @load="calcHeight($event,'weight-loss-calculator')" ref="weight-loss-calculator" :src="serverUrl+'calculators/weight-loss-calculator.php'" frameborder="0"></iframe>
      </b-col>

    </b-row>
  </div>
</template>

<script>

import InfoService from '@/services/info.service.js';
import * as constants from '../helpers/Constants.js'

export default {
  name: 'dashboard',
  data: function () {
    return {
      activeTab: "bmr-calc",
      serverUrl : constants.APIURL,
      calculators : {}
    }
  },
  created() {
  },
  computed: {
    language() {
        return this.$store.getters['UserModules/getLanguage']
    }
  },
  methods : {
    setActive(tab){
      this.activeTab = tab;
    },
    calcHeight(ev,id){
      var iframe = this.$refs[id];
      // iframe.style.height = "100%";
      // iframe.style.width = "100%";
      if(!this.calculators[id]){
        this.calculators[id] = {
          height:iframe.contentWindow.document.body.scrollHeight+100,
          width:iframe.contentWindow.document.body.scrollWidth+100
        };
        iframe.style.height = iframe.contentWindow.document.body.scrollHeight+100 + 'px';
        iframe.style.width = iframe.contentWindow.document.body.scrollWidth+100 + 'px';
      }else{
        iframe.style.height = this.calculators[id].height + 'px';
        iframe.style.width = this.calculators[id].width + 'px';
      }
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
